import { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { privateStudentRoutes, privateAdminRoutes, publicRoutes } from '../router';
import { AuthContext } from '../context';

const AppRouter = () => {
    const { isAuthStudent, isAuthAdmin, roleName } = useContext(AuthContext);
    return (
        (isAuthAdmin && roleName == "admin" )
            ?
            <Routes>
                {privateAdminRoutes.map(route =>
                    <Route
                        element={route.element}
                        path={route.path}
                        exact={route.exact}
                        key={route.path}
                    />
                )}
                {publicRoutes.map(route =>
                    <Route
                        element={route.element}
                        path={route.path}
                        exact={route.exact}
                        key={route.path}
                    />
                )}
                <Route
                    element={<Navigate to='/admin' />}
                    path='*'
                    exact={true}
                />
            </Routes> 
            :
        ((isAuthStudent && roleName == "moderator") && isAuthAdmin)
        ?
        <Routes>
            {privateStudentRoutes.map(route =>
                <Route
                    element={route.element}
                    path={route.path}
                    exact={route.exact}
                    key={route.path}
                />
            )}
            {publicRoutes.map(route =>
                <Route
                    element={route.element}
                    path={route.path}
                    exact={route.exact}
                    key={route.path}
                />
            )}
            <Route
                element={<Navigate to='/student/anket' />}
                path='*'
                exact={true}
            />
        </Routes>
        :
        <Routes>
            {publicRoutes.map(route =>
                <Route
                    element={route.element}
                    path={route.path}
                    exact={route.exact}
                    key={route.path}
                />
            )}
            <Route
                element={<Navigate to='/' />}
                path='*'
                exact={true}
            />
        </Routes>
    );
};

export default AppRouter;
